'use strict';

const debounce = require('lodash/debounce');
const $header = $('.app-header');

function handleToggleHeader() {
    const scrollTop = $(window).scrollTop();
    const areHeaderElementsHidden = $header.hasClass('header-hidden');
    const stickyNav = $('.sticky-navbar');

    if (stickyNav.length === 0) {
        return;
    }

    const navTopPostion = stickyNav.position().top;

    if (scrollTop === 0) {
        $header.removeClass('header-sticky header-hidden');
        return;
    }

    if (scrollTop > navTopPostion) {
        if (scrollTop > 0 && !areHeaderElementsHidden) {
            $header.addClass('header-sticky header-hidden');
        }
    }
}

function toggleHeader() {
    $(window).on('scroll', debounce(handleToggleHeader));
}

module.exports = {
    toggleHeader
};
